import { forwardRef, useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CheckboxesTags = forwardRef(
  (
    {
      data,
      currentQuestion,
      scrollToQuestion,
      choises,
      latestQuestion,
      handlePayload,
      handleChange,
      setPersistedData,
      value,
      isEdit,
      latestStepQuestion,
      payload,
    },
    ref
  ) => {
    const tags = data.groupedData ? Object.values(value).flat() : value;
    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)");

    const [show, setShow] = useState(false);

    const onTagsChange = (event, values) => {
      if (data.persistData) {
        setPersistedData(values);
      }
      if (data.groupedData) {
        const groupByCategory = values.reduce((group, product) => {
          const { category } = product;
          group[category] = group[category] ?? [];
          group[category].push(product.value);
          return group;
        }, {});
        handlePayload(data, groupByCategory);
      } else {
        handlePayload(
          data,
          values.map((el) => el.value)
        );
      }
      if (Array.isArray(values) && values.length === 0) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    useEffect(() => {
      if (data.id === 43) {
        if (
          payload["WebApp_Architectures_F"].includes("eventdriven") ||
          payload["WebApp_Architectures_F"].includes("Serverless") ||
          payload["WebApp_Architectures_F"].includes("Microservice") ||
          payload["WebApp_Architectures_F"].includes("3tier")
        ) {
          data.nextQuestion = 44;
          data.nextStepQuestion = 44;
        } else {
          data.nextQuestion = 45;
          data.nextStepQuestion = 45;
        }
      }
    }, [data.id, payload]);

    const nextQuestionHandler = (height, value) => {
      // handlePayload(data, tags);
      scrollToQuestion(data, height, value);
    };
    return (
      <div style={{ padding: isMobile ? "100px 0px" : "100px 20px" }} ref={ref}>
        <>
          <Typography variant="subtitle1">{t(data.question)}</Typography>
          <br></br>
          <Autocomplete
            value={choises.filter((el) => tags?.includes(el.value))}
            fullWidth
            multiple
            onChange={onTagsChange}
            groupBy={(option) => t(option.category)}
            id="checkboxes-tags-demo"
            options={choises}
            disableCloseOnSelect
            getOptionLabel={(option) => t(option.value)}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {t(option.value)}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label={t(data.label)} />
            )}
          />
          {show && (
            <span className="error-message-autocomplete">
              {t("required_field")}
            </span>
          )}

          {currentQuestion === data.id &&
          currentQuestion !== latestQuestion &&
          !(isEdit && latestStepQuestion === data.id) ? (
            <>
              {" "}
              <Button
                onClick={() => {
                  nextQuestionHandler(ref.current.clientHeight, tags);
                }}
                disabled={
                  data.required &&
                  (data.groupedData
                    ? Object.keys(value).length === 0
                    : value.length === 0)
                }
                style={{ height: "50px", marginTop: "20px" }}
                color="secondary"
                variant="contained"
                fullWidth
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <> </>
          )}
        </>
      </div>
    );
  }
);

export default CheckboxesTags;
